"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { TfiAnnouncement } from "react-icons/tfi";
import { IoClose } from "react-icons/io5";
import { Button } from "@/components/ui/button";

type AnnouncementBarProps = {
  initialData: {
    message: string;
    visible: boolean;
  } | null;
};

export default function AnnouncementBar({
  initialData,
}: AnnouncementBarProps) {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (pathname !== "/" || !initialData?.visible) return;
    if (window.location.hash) return;
    if (sessionStorage.getItem("announcement_shown") === "true") return;

    const timer = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("announcement_shown", "true");
    }, 600);

    return () => clearTimeout(timer);
  }, [pathname, initialData?.visible]);

  if (pathname !== "/") return null;
  if (!initialData?.visible) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        showCloseButton={false}
        className="
          bg-white
          overflow-hidden
          sm:max-w-2xl
          sm:max-h-[90svh]
          sm:rounded-2xl
          sm:border-white
        "
      >
        {/* HEADER */}
        <div
          className="
            sticky
            top-0
            z-10

            flex items-center justify-between gap-3

            bg-white

            px-5
            pb-4

            pt-[max(16px,env(safe-area-inset-top))]
          "
        >
          <DialogTitle className="flex items-center gap-3 text-xl sm:text-2xl text-black tracking-wide">
            <span className="hidden sm:inline-flex h-11 w-11 items-center justify-center rounded-full bg-primary/10">
              <TfiAnnouncement className="h-6 w-6 text-black" />
            </span>

            <span className="leading-tight">
              Rozvoz nožů po Olomouci a Přerově zdarma.
            </span>
          </DialogTitle>

          <DialogClose asChild>
            <Button
              variant="ghost"
              size="icon"
              className="
                shrink-0
                rounded-full
                cursor-pointer

                text-black/80
                bg-black/10

                hover:text-black
                hover:bg-black/20
                hover:rotate-90

                transition-all
                duration-300
              "
            >
              <IoClose className="h-6 w-6" />
            </Button>
          </DialogClose>
        </div>

        {/* CONTENT */}
        <div
          className="
            flex-1
            min-h-0
            overflow-y-auto
            overscroll-contain

            px-5
            pb-8
          "
        >
          <DialogDescription
            asChild
            className="text-left text-base leading-relaxed text-black"
          >
            <div>
              <div className="rounded-xl border border-primary/15 bg-primary/5 p-5">
                <p className="mb-4 text-lg font-semibold">
                  Broušení nožů poštou!
                </p>

                <p className="mb-4">
                  Nemáte možnost dostat se ke mně osobně? Nevadí...
                </p>

                <p className="mb-4">
                  Nože a další nástroje mi můžete jednoduše poslat – já je
                  nabrousím a pošlu zpět.
                </p>

                <hr className="border-primary/20 my-4" />

                <p className="mb-4">
                  Při částce za broušení nad 800 Kč poštovné na zpáteční cestu
                  zdarma.
                </p>

                <p className="mb-4">
                  Rozvoz a zapůjčení sady nožů po Olomouci a Přerově zdarma.
                </p>

                <p className="mb-4">
                  Nová služba{" "}
                  <a
                    href="/brouseni-nozu-postou"
                    className="text-primary underline"
                  >
                    broušení nožů a nástrojů poštou
                  </a>
                  !
                </p>

                <hr className="border-primary/20 my-4" />

                <p className="mb-4">
                  Pokud si nejste jisti, zavolejte nebo mi napište!
                </p>

                <p className="mb-4">
                  Jiří Lések
                  <br />
                  Tršice 271
                  <br />
                  78357
                </p>

                <a
                  href="tel:+420720126985"
                  className="
                    inline-flex
                    items-center
                    justify-center
                    rounded-md
                    bg-primary
                    px-5
                    py-2.5
                    text-sm
                    font-semibold
                    text-white
                    hover:bg-primary/90
                  "
                >
                  Zavolejte mi!
                </a>
              </div>
            </div>
          </DialogDescription>
        </div>
      </DialogContent>
    </Dialog>
  );
}